// src/features/security/components/SecurityHeader.tsx
import { PageHeader } from '../../../app/components/foundation';

/**
 * Page-top header for Security Foundation. Reuses the shared
 * PageHeader primitive (same contract every other feature's header
 * uses) and puts one disabled placeholder in the actions slot to
 * reserve visual space for a future "افزودن ماژول امنیتی" action. It
 * has no click handler and does nothing yet — wiring it to a real
 * create flow is a later phase, not this one. Same pattern as
 * commission/components/CommissionHeader.tsx and
 * users/components/UsersHeader.tsx.
 */
export function SecurityHeader() {
  return (
    <PageHeader
      title="مرکز امنیت"
      description="مشاهده و مدیریت ماژول‌ها و سیاست‌های امنیتی پلتفرم."
      actions={
        <button
          type="button"
          disabled
          className="vania-security-action-placeholder"
          title="در فاز بعدی فعال می‌شود"
        >
          افزودن ماژول امنیتی
        </button>
      }
    />
  );
}
